/* ==========================================
   LEOBELA
   Custom JavaScript
========================================== */

document.addEventListener('DOMContentLoaded', () => {

    initHeaderMenu();
    initLeobelaAnnouncementBars();
    initLeobelaHeroVideos();
    initProductAccordion();
    initJudgeMeButton();

});

/* ==========================================
   HEADER MENU
========================================== */

function initHeaderMenu() {

  const menuItems = document.querySelectorAll('header-menu > details');

  menuItems.forEach((item) => {

    item.addEventListener('mouseenter', () => {
      item.setAttribute('open', '');
    });

    item.addEventListener('mouseleave', () => {
      item.removeAttribute('open');
    });

  });

}

/* ==========================================
   ANNOUNCEMENT BAR
========================================== */

function initLeobelaAnnouncementBars() {

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-leobela-announcement-bar]').forEach((bar) => {
    if (bar.dataset.leobelaAnnouncementInitialized === 'true') return;
    bar.dataset.leobelaAnnouncementInitialized = 'true';

    const messages = Array.from(bar.querySelectorAll('.leobela-announcement-bar__message'));
    const interval = Number(bar.dataset.rotationInterval) || 4500;
    const transitionDelay = 300;
    let activeIndex = 0;
    let rotationTimer;

    const showMessage = (index) => {
      messages.forEach((message, messageIndex) => {
        const isActive = messageIndex === index;
        message.classList.toggle('is-active', isActive);
        message.setAttribute('aria-hidden', (!isActive).toString());
      });
      activeIndex = index;
    };

    const stopRotation = () => {
      window.clearInterval(rotationTimer);
      rotationTimer = undefined;
      showMessage(0);
    };

    const startRotation = () => {
      if (messages.length < 2 || reducedMotion.matches || rotationTimer) return;

      rotationTimer = window.setInterval(() => {
        const nextIndex = (activeIndex + 1) % messages.length;
        messages[activeIndex].classList.remove('is-active');
        messages[activeIndex].setAttribute('aria-hidden', 'true');

        window.setTimeout(() => showMessage(nextIndex), transitionDelay);
      }, interval);
    };

    showMessage(0);
    startRotation();

    reducedMotion.addEventListener('change', () => {
      if (reducedMotion.matches) {
        stopRotation();
      } else {
        startRotation();
      }
    });
  });
}

/* ==========================================
   HERO VIDEO
========================================== */

function initLeobelaHeroVideos() {

  const heroVideos = document.querySelectorAll('[data-leobela-hero-video]');

  heroVideos.forEach((video) => {
    const hero = video.closest('.leobela-hero-media--video-enabled');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setPlaybackRate = () => {
      try {
        if (video.playbackRate !== 0.6) {
          video.playbackRate = 0.6;
        }
      } catch (error) {
        // The video remains playable at its native rate if the browser rejects the enhancement.
      }
    };

    const showVideo = () => {
      hero?.classList.remove('leobela-hero-media--autoplay-rejected');
      hero?.classList.add('leobela-hero-media--video-ready');
    };
    const showFallback = () => hero?.classList.remove('leobela-hero-media--video-ready');
    const showVideoWhenPlaying = () => {
      if (!video.paused) showVideo();
    };
    const handleAutoplayRejection = () => {
      showFallback();
      hero?.classList.add('leobela-hero-media--autoplay-rejected');
    };
    const attemptAutoplay = () => {
      if (reducedMotion.matches) return;

      try {
        video.defaultMuted = true;
        video.muted = true;

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(handleAutoplayRejection);
        }
      } catch (error) {
        handleAutoplayRejection();
      }
    };

    if (video.readyState >= 1) {
      setPlaybackRate();
    }

    if (!video.paused && video.readyState >= 2) {
      showVideoWhenPlaying();
    }

    video.addEventListener('loadedmetadata', setPlaybackRate);
    video.addEventListener('play', setPlaybackRate);
    video.addEventListener('ratechange', setPlaybackRate);
    video.addEventListener('loadeddata', showVideoWhenPlaying);
    video.addEventListener('canplay', showVideoWhenPlaying);
    video.addEventListener('playing', showVideo);
    video.addEventListener('emptied', showFallback);
    video.addEventListener('error', showFallback);

    attemptAutoplay();
  });

}

/* ==========================================
   PRODUCT ACCORDION
========================================== */

function initProductAccordion() {

    const accordions = document.querySelectorAll('.product__accordion details');

    accordions.forEach((accordion) => {

        accordion.addEventListener('toggle', () => {

            if (!accordion.open) return;

            accordions.forEach((item) => {

                if (item !== accordion) {
                    item.removeAttribute('open');
                }

            });

        });

    });

}

/* ==========================================
   JUDGE.ME BUTTON
========================================== */

function initJudgeMeButton() {

    const applyStyle = () => {

        const button = document.querySelector('.jm-button--primary');

        if (!button) return;

        button.classList.remove('jm-button', 'jm-button--primary');
        button.classList.add('button', 'button--primary');

        button.removeAttribute('style');

    };

    applyStyle();

    const observer = new MutationObserver(applyStyle);

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

}
